import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ASSET_BASE = process.env.REACT_APP_BACKEND_URL;

export const KOMERCES_DEFAULT = {
  branding_level: 1,
  is_komerces_default: true,
  name: 'Komerces',
  nom_affiche: null,
  logo_url: null,
  favicon_url: null,
  couleur_primaire: '#007BFF',
  couleur_secondaire: '#0056b3',
  tagline: null,
  footer_text: null,
  show_komerces_footer: true,
};

let _current = KOMERCES_DEFAULT;
export const getBranding = () => _current;

function setFavicon(href) {
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = href;
}

/** Applique le branding : variables CSS de couleur + favicon. */
export function applyBranding(b) {
  _current = b || KOMERCES_DEFAULT;
  const root = document.documentElement;
  root.style.setProperty('--brand-primary', _current.couleur_primaire || '#007BFF');
  root.style.setProperty('--brand-secondary', _current.couleur_secondaire || '#0056b3');
  if (_current.favicon_url) {
    setFavicon(`${ASSET_BASE}${_current.favicon_url}`);
  }
  try {
    localStorage.setItem('agence_branding', JSON.stringify(_current));
  } catch (_) { /* noop */ }
  try {
    window.dispatchEvent(new Event('branding-applied'));
  } catch (_) { /* noop */ }
  return _current;
}

/** Source du logo à afficher (logo agence si niveau ≥ 2, sinon logo Komerces du build). */
export function logoSrc(b) {
  const br = b || _current;
  if (br && br.logo_url) return `${ASSET_BASE}${br.logo_url}`;
  return '/logo_komerces_fonce.svg';
}

/** Logo pour FOND SOMBRE (sidebar, login sombre) : version claire si dispo, sinon logo standard. */
export function logoSrcOnDark(b) {
  const br = b || _current;
  if (br && br.logo_url_dark) return `${ASSET_BASE}${br.logo_url_dark}`;
  return logoSrc(br);
}

/**
 * Convertit un logo_url stocké (souvent /api/media/agence_logos/… = route authentifiée)
 * en URL PUBLIQUE affichable dans une <img> (qui ne peut pas envoyer de token).
 */
export function agenceLogoUrl(storedUrl) {
  if (!storedUrl) return null;
  if (/^https?:\/\//i.test(storedUrl)) return storedUrl;
  const fname = storedUrl.split('/').pop();
  return `${ASSET_BASE}/api/public/agence-logo/${fname}`;
}

export async function fetchPublicBranding(host, previewAgenceId, previewLevel) {
  try {
    const params = previewAgenceId
      ? { preview_agence_id: previewAgenceId, ...(previewLevel ? { preview_level: previewLevel } : {}) }
      : { host };
    const { data } = await axios.get(`${API}/public/branding`, { params });
    return data;
  } catch (_) {
    return KOMERCES_DEFAULT;
  }
}

export async function fetchMyBranding() {
  try {
    const { data } = await axios.get(`${API}/my-agence/branding`);
    return data;
  } catch (_) {
    return KOMERCES_DEFAULT;
  }
}
